export enum PageId {
  space = '2rrb5ka4jpe4',
  accessToken = 'h8qz-oNyVg5Mz0rAZ09hktrjETMGZyXy4apmlklG2wc',
  home = 'homePage',
  navHeader = 'navHeader',
  psHeader = 'psHeader',
  psHeaderNew = 'psHeaderNew',
  psFooter = 'psFooterNew',
  header = 'header',
  footer = 'footer',
  environment = 'master',
  companyCareers = 'companyCareers',
  companyLicences = 'companyLicences',
  collectPage = 'collectPage',
  companyPage = 'companyPage',
  coveragePage = 'coveragePage',
  pricingPage = 'pricingPage',
  pricingPageKenya = 'pricingPageKenya',
  blogPage = 'blogPage',
  blogArticle = 'blogArticle',
  companyAbout = 'PScompanyAbout',
  companyGraduateScheme = 'companyGraduateScheme',
  solutionsPage = 'solutionsPage',
  globalAccountPage = 'psSolutionsBusinessAccountGlobalAccount',
  localAccountPage = 'psSolutionsLocalAccounts',
  vPayPage = 'psSolutionsVPay',
  LocalPaymentsPage = 'psSolutionsLocalPayments',
  internationalPaymentsPage = 'psInternationalPayments',
  landingPage = 'landingPage',
  homePage = 'homePageAlt',
  newhomepage = 'productSegmentedHomepageNew',
  homepageUAE = 'localHomePageUAENew',
  landingIntentUK = 'productintentaffiliate',
  remitfinder = 'productintentaffiliateRemitfinder',
  coreApiPage = 'psCoreAPIs',
  businessAcc = 'psBusinessAccounts',
  treasuryManagement = 'psFXandTreasuryManagement',
  expenseManagement = 'psExpenseManagement',
  invoicePayments = 'psInvoicePayments',
  multiCurrencyWallet = 'psSolutionsMulticurrencyWallet',
  paymentLinksPage = 'psSolutionsPaymentLinks',
  solutionsAutomate = 'solutionsAutomate',
  solutionsAutomateAPI = 'solutionsAutomateAPI',
  solutionsConvert = 'solutionsConvert',
  solutionsConvertAdvancedLiquidity = 'psSolutionsAdvancedLiquidity',
  solutionsSpotFx = 'psSolutionsSpotFX',
  solutionsOTCPage = 'psSolutionsOTCFX',
  solutionsConvertMarketplace = 'psSolutionsMarketplaces',
  solutionsAutoExchange = 'psSolutionsAutoExchange',
  solutionsConvertFX = 'solutionsConvertFX',
  solutionsHold = 'solutionsHold',
  solutionsHoldTreasuryManagement = 'solutionsHoldTreasuryManagement',
  solutionsPay = 'solutionsPay',
  payWalletToWallet = 'payWalletToWallet',
  payCorporateCards = 'payCorporateCards',
  solutionsVirtualCard = 'psSolutionsVirtualCards',
  solutionsPhysicalCard = 'psSolutionsPhysicalCards',
  payPayouts = 'payPayouts',
  company404 = 'company404',
  newsroomPage = 'newsroomPage',
  newsroomArticle = 'newsroomArticle',
  companyPartners = 'companyPartners',
  coverageGeographies = 'coverageGeographies',
  companyResourcesFAQs = 'companyResourcesFAQs',
  faqArticle = 'faqArticle',
  companyResourcesFAQsSearchResult = 'companyResourcesFAQsSearchResult',
  coverageCurrenciesAlt = 'coverageCurrenciesAlt',
  coverageCurrencyKenyanShillings = 'coverageCurrencyKenyanShillings',
  coverageCountryNigeriaAlt = 'coverageCountryNigeriaAlt',
  solutionsPayPaymentLinks = 'solutionsPayPaymentLinks',
  eventsPage = 'eventsPage',
  eventArticlePages = 'eventArticlePages',
  jobDescription = 'jobDescription',
  useCasesPage = 'useCasesPage',
  companyResourcesSupportContactForm = 'companyResourcesSupportContactForm',
  companyResourcesSupportContactFormAfterSubmit = 'companyResourcesSupportContactFormAfterSubmit',
  solutionsConvertMarketplaceSellSide = 'solutionsConvertMarketplaceSellSide',
  solutionsConvertMarketplaceBuySide = 'solutionsConvertMarketplaceBuySide',
  otherCompanyPages = 'otherCompanyPages',
  termsAndConditions = 'termsAndConditions',
  usLicenses = 'usLicenses',
  canadaTermsOfService = 'canadaTermsandconditionsandprivacypolicy',
  privacyPolicy = 'privacyPolicy',
  cookiePolicy = 'cookiePolicy',
  modernSlaveryStatement = 'modernSlaveryStatement',
  whitepapersAndReports = 'whitepapersAndReports',
  whitepapersAndReportsArticle = 'whitepapersAndReportsArticle',
  companySizes = 'companySizes',
  customersLandingPage = 'customersLandingPage',
  customerStoryArticlePage = 'customerStoryArticlePage',
  webinarsPodcasts = 'webinarsPodcasts',
  webinarsPodcastsArticles = 'webinarsPodcastsArticles',
  sitemap = 'sitemap',
  // atlasLandingPage = 'psAtlas',
  atlasLandingPage = 'psV2Atlas',
  startupPage = 'psStartUp',
  scaleupPage = 'psScaleUp',
  enterprisePage = 'psCompanySizesEnterprise',
  vertoConnectPage = 'vertoConnect',
  homePageNigeria = 'localHomePageNigeria',
  homePageKenya = 'localHomePageKenya',
  solutionsEmbeddedCollectionsPage = 'pSSolutionsEmbeddedCollectionsandPayouts',
  solutionsAPIsPage = 'psVertoAPIs',
  MassPayoutsPage = 'psSolutionsMassPayouts',
  referPage = 'psSolutionsCustomerReferrals',
  countryKenya = 'countryKenya',
  countryNigeria = 'countryNigeria',
  countrySA = 'countrySouthAfrica',
  countryUS = 'countryUs',
  countryUK = 'countryUk',
  solutionsReservePage = 'psSolutionsVertoReserve',
  financialTimesCampaign = 'financialTimesCampaign'
}
